import img1x6x6Better from "@/assets/blog/1x6x6-1-better-cedar.jpg";

export const blogArticles = [
  {
    id: "steel-vs-wood-fence-posts",
    title: "Steel vs Wood Fence Posts: Which Is the Better Long-Term Investment?",
    category: "Fence Posts",
    description: "Compare 4x4 black steel fence posts with traditional wood posts. 40-year warranty vs 10-15 year lifespan. Learn why steel posts are ideal for wet Seattle soil.",
    image: "/lovable-uploads/barrier-boss-4x4-steel-post.webp",
    readTime: "8 min read",
    publishDate: "December 2025"
  },
  {
    id: "cedar-steel-hybrid-fence",
    title: "Cedar/Steel Hybrid Fence: The Ultimate Guide to Modern Privacy Fencing",
    category: "Premium Fencing",
    description: "Discover the cedar/steel hybrid fence system - 26 gauge corrugated steel panels with HDP NoFade™ paint and cedar framing. Learn about pricing ($80/LF), 30-year warranty options, and why this is the ultimate privacy fence investment.",
    image: "/lovable-uploads/cedar-aluminum-hybrid-fence-hero.png",
    readTime: "10 min read",
    publishDate: "December 2025"
  },
  {
    id: "cedar-board-grade",
    title: "Choosing Cedar Fence Board Grade: A Complete Guide",
    category: "Materials",
    description: "Learn about the different cedar fence board grades MyFence.com offers, from #1-2 Face to Clear Cedar, and how to choose the right grade for your fence project.",
    image: img1x6x6Better,
    readTime: "6 min read",
    publishDate: "November 30, 2024"
  },
  {
    id: "virtual-quote-tool",
    title: "Get Your Instant Fence Quote with Our Advanced Virtual Tool",
    category: "Pricing",
    description: "Discover how our revolutionary virtual quote tool lets you choose fence styles, customize posts, add upgrades, and draw your property for accurate instant pricing.",
    image: "/lovable-uploads/96fca880-7890-4f75-83cc-4a78693640a9.png",
    readTime: "6 min read",
    publishDate: "January 2025"
  },
  {
    id: "fence-cost-seattle",
    title: "How Much Does a 6-Foot Privacy Fence Cost in Seattle?",
    category: "Pricing", 
    description: "Get a comprehensive breakdown of 6-foot privacy fence costs in Seattle, including materials, labor, and factors that affect your total investment.",
    image: "/lovable-uploads/840c5f7f-0578-45fa-9b5c-195760503695.png",
    readTime: "7 min read",
    publishDate: "December 2024"
  },
  {
    id: "seattle-fence-cost-2025",
    title: "How Much Does a Wooden Fence Cost in Seattle in 2025?",
    category: "Pricing",
    description: "Updated pricing guide for wooden fence installation in Seattle for 2025, including market trends and cost-saving tips for homeowners.",
    image: "/lovable-uploads/936790e3-e01a-4dcd-bf22-e5ac97188fd1.png",
    readTime: "6 min read",
    publishDate: "January 2025"
  },
  {
    id: "fence-cost-shared-with-neighbor",
    title: "Should My Neighbor Split Our Fence Cost With Me?",
    category: "Legal",
    description: "Navigate the complexities of shared fence costs with neighbors, including Washington State laws and best practices for property line fencing.",
    image: "/lovable-uploads/92eb7242-9591-46bf-96c5-a1c66b6fe149.png",
    readTime: "4 min read",
    publishDate: "December 2024"
  },
  {
    id: "fence-cleaning-staining",
    title: "How Should I Clean My Fence for Staining?",
    category: "Maintenance",
    description: "Learn proper fence cleaning techniques before staining, including softwashing benefits and when to hire Seattle professionals like NW Pro Wash LLC.",
    image: "/lovable-uploads/78133561-db65-4e96-932f-e60c0eeaf449.png",
    readTime: "8 min read",
    publishDate: "January 2025"
  },
  {
    id: "how-to-stain-fence",
    title: "How Do I Stain My Fence?",
    category: "Maintenance",
    description: "Complete guide to fence staining in Seattle - brushing vs spraying techniques, best practices, and step-by-step instructions for lasting results.",
    image: "/lovable-uploads/44503efa-b853-47c1-8bd9-52b13e55fbd1.png",
    readTime: "10 min read",
    publishDate: "January 2025"
  },
  {
    id: "fence-ownership",
    title: "How to Tell If a Fence Is Yours or Neighbors",
    category: "Legal",
    description: "Learn how to determine fence ownership, understand property boundaries, and resolve disputes with neighbors in Washington State.",
    image: "/lovable-uploads/815744dc-6440-4c65-917a-afb302ed2788.png",
    readTime: "6 min read",
    publishDate: "January 2025"
  },
  {
    id: "street-setback",
    title: "How Far Does My Fence Have To Be From The Street? A Guide To Washington State Fence Laws",
    category: "Legal",
    description: "Understand Washington State setback requirements, municipal codes, and legal guidelines for fence placement near streets and sidewalks.",
    image: "/lovable-uploads/793a9940-252a-431c-bc9c-f109022e1b92.png",
    readTime: "8 min read",
    publishDate: "January 2025"
  },
  {
    id: "property-line",
    title: "Can You Build a Fence on the Property Line?",
    category: "Legal",
    description: "Discover the rules and regulations for building fences on property lines, including permits, neighbor agreements, and legal considerations.",
    image: "/lovable-uploads/913ab5db-5bb0-4601-b16b-cb82980c1a02.png",
    readTime: "5 min read",
    publishDate: "January 2025"
  },
  {
    id: "material-cost-2025",
    title: "What Is The Material Cost For Wood Fence in 2025?",
    category: "Pricing",
    description: "Get detailed pricing for wood fence materials in 2025, including cedar, pine, and composite options with current market rates.",
    image: "/lovable-uploads/96a63d79-9269-47b1-96ef-9727feb60536.png",
    readTime: "7 min read",
    publishDate: "January 2025"
  }
];